import { styled } from "@mui/material/styles";

const ImageContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "15px",
  marginTop: "10px",
  flexWrap: "wrap",
  "& .ImageItem": {
    position: "relative",
    "& img": {
      width: "100px",
      height: "100px",
      objectFit: "cover",
    },
    // width: "100px",
    // height: "100px",
    // backgroundRepeat: "no-repeat",
    // backgroundSize: "cover",
    // backgroundPosition: "center",
  },
  "& .RemoveIcon": {
    width: "20px",
    height: "20px",
    padding: "0px",
    position: "absolute",
    right: "-10px",
    top: "-10px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "10px",
    margin: "0",
    background: "#000",
    borderRadius: "50%",
  },
}));

export { ImageContainer };
